/*
 * UnconditionalHideNode Messages
 *
 * This contains all the text for the UnconditionalHideNode container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.UnconditionalHideNode';

export default defineMessages({
  logicRules: {
    id: `${scope}.logicRules`,
    defaultMessage: 'Logic rules',
  },
  carryForward: {
    id: `${scope}.carryForward`,
    defaultMessage: 'Carry forward',
  },
  quotas: {
    id: `${scope}.quotas`,
    defaultMessage: 'Quotas',
  },
});
